import React, { useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
import "./AddOtherRevenue.scss";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import AddInputField from "app/views/commonComponents/AddInputField/AddInputField";
const AddOtherRevenue = ({ onClose }) => {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  console.log("HelloModal2");
  return (
    <Card className={"addOtherRevenueCard"}>
      <CardBody>
        <div className="addOtherRevenueContainer">
          <div className="addOtherRevenueTitle">
            <div className="addOtherRevenueStyle">Add Other Revenue</div>
          </div>
          <div className="fieldsConatiner">
            {" "}
            <AddInputField
              fieldName="Amount"
              fieldValue={amount}
              inputType={"number"}
              onChange={(e) => setAmount(e.target.value)}
              style={{ width: "100%" }}
            />
            <AddInputField
              fieldName="Description"
              fieldValue={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
          <div className="removeSection">
            <Buttons
              size={"small"}
              dimensions={"responsive"}
              buttonType={"secondary"}
              onClick={onClose}
            >
              Cancel
            </Buttons>
            <Buttons
              size={"small"}
              dimensions={"responsive"}
              buttonType={"primary"}
              onClick={() => {
                onClose();
              }}
            >
              Add Other Revenue
            </Buttons>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default AddOtherRevenue;
